/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/reInterpolate.js
 ** module id = 52
 ** module chunks = 0
 **/